<template>
	<div class="w-full mt-5">
		<vs-row vs-justify="center">
			<vs-col vs-type="flex" vs-justify="center" vs-align="start" vs-lg="6" vs-sm="12" vs-xs="12" class="px-2">
				<Number :label="$t('MODALS.flex.minimumSize')" v-model="properties.min" :min="1"></Number>
			</vs-col>
			<vs-col vs-type="flex" vs-justify="center" vs-align="start" vs-lg="6" vs-sm="12" vs-xs="12" class="px-2">
				<Number :label="$t('MODALS.flex.maximumSize')" v-model="properties.max" :min="1"></Number>
			</vs-col>
		</vs-row>
	</div>
	  
</template>
<script type="text/javascript">	
	import Number from '../../../components/Number.vue';

	export default {		
		components: { Number },
		props: {
			properties: {
				type: Object,
				required: false,
				default: {}
			}
		}
	}
	
</script>